import { post, del, get, put, postNoAuth, putNoAuth } from './api/web.service';

// User management ID acquisition API - <IF-UM-USER-0010>
export const getUserMngId = (mail_address) => {
  return get(`/user/id?mail_address=${mail_address}`);
};

// API to register invited user information as a temporary user and send an invitation email  -  <IF-UM-USER-0003>
export const registerInvitedUser = (payload) => {
  return post('/temporary_user', payload);
};

// Change user email -  <IF-UM-USER-0004>
export const changeEmail = (user_mng_id, payload) => {
  return put(`/user/${user_mng_id}`, payload);
};

// Delete avatar - <IF-UM-USER-0006>
export const removeAvatar = (avatarId) => {
  return del(`/user/avatar/${avatarId}`);
};

// MFA reset request API - <IF-UM-USER-0008>
export const resetMFA = (payload) => {
  return postNoAuth(`/user/mfa`, payload);
};

// MFA reset request by token API - <IF-UM-USER-0009>
export const resetMFAToken = (payload) => {
  return putNoAuth(`/user/mfa`, payload);
};
